module.exports = __webpack_public_path__ + "static/media/Oriental.134f530b.png";